import React from 'react';
import 'react-app-polyfill/ie11';
import { ToastContainer } from 'react-toastify';
import { HashRouter } from 'react-router-dom';
import { Provider } from 'react-redux';

import './assets/base.scss';
import configureStore from './config/configureStore';
import AppProvider from './Context/Context';
import Loader from './Layout/AppLoader/AppLoader';
import Routes from './routes/Routes';

const store = configureStore();

function App() {
  return (
    <Provider store={store}>
      <AppProvider>
        <HashRouter>
          <Loader />
          <Routes />
          <ToastContainer autoClose={3500} hideProgressBar />
        </HashRouter>
      </AppProvider>
    </Provider>
  );
}

export default App;
